export default {
  data() {
    return {}
  },
  methods: {
    // 路由跳转
    push(param) {
      if (param) {
        this.$router.push(param);
      }
    },
    // 返回
    back(param) {
      if (param && !param.target) {
        this.$router.replace(param);
      } else {
        this.$router.back(); //返回上一层
      }
    },
  }
}